export default function Footer() {
  const year = new Date().getFullYear();
  const groups: { title: string; links: { href: string; label: string }[] }[] = [
    {
      title: "浏览内容",
      links: [
        { href: "#latest", label: "最新求证" },
        { href: "#reversal", label: "反转追踪" },
        { href: "#guide", label: "分辨指南" },
        { href: "#categories", label: "关注栏目" },
      ],
    },
    {
      title: "关于我们",
      links: [
        { href: "#about", label: "平台理念" },
        { href: "#about", label: "读者口碑" },
        { href: "#faq", label: "常见问题" },
        { href: "#contact", label: "联系与线索" },
      ],
    },
  ];

  return (
    <footer className="border-t border-background-200 bg-secondary-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.2fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-700 font-heading text-base font-bold text-background-50">
                55
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料求证</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              网络争议传闻的真假求证平台：以证据链、反转时间线与当事人澄清为核心，帮你在信息洪流中理清来龙去脉。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-mail-line"].map((ic, i) => (
                <a
                  key={ic}
                  href="#contact"
                  aria-label={`社交入口 ${i + 1}`}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <i className={`${ic} text-base`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {groups.map((g) => (
            <nav key={g.title} aria-label={g.title}>
              <h3 className="text-sm font-bold text-foreground-950">{g.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {year} 55黑料求证 · 本平台所有求证结论均以公开可查证据为依据，内容仅供参考。
          </p>
          <p className="text-xs text-foreground-400">
            <i className="ri-focus-3-line mr-1" aria-hidden="true"></i>
            求真 · 辟谣 · 反转追踪
          </p>
        </div>
      </div>
    </footer>
  );
}